import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { Pharmacy } from '@enums/pharmacies';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the ED treatment type.
 */
export const EdTreatmentType = new TreatmentType({
  id: '16',
  name: ConsultationTreatmentTypes.Ed,
  designatedPharmacyId: Pharmacy.TAHA,
  genderSettings: new TreatmentGenderSettings({
    disallowed: [Gender.Female],
    errorMessage:
      'Based on your sex assigned at birth, you are not a treatable candidate and will not be prescribed medication.',
  }),
  requireHeightAndWeight: true,
  shippingService: 'USPS First-Class - 3-4 Days (Free)',
});
